import React, { forwardRef } from 'react'
import { Typography as MuiTypography } from '@material-ui/core'

import { TypographyProps, DefaultTypographyComponent } from './TypographyProps'
import { useTypographyStyles } from './TypographyStyles'

interface TypographyType {
  <C extends React.ElementType = DefaultTypographyComponent>(
    props: TypographyProps<C> & { component?: C },
  ): React.ReactElement
  displayName?: string
}

// eslint-disable-next-line react/display-name -- false positive
export const Typography = forwardRef<HTMLElement, TypographyProps>(
  ({ color, variant = 'body1', weight, ...restProps }, ref) => {
    const classes = useTypographyStyles({ color, variant, weight })
    const variantMapping = { subtitle1: 'p' }
    return (
      <MuiTypography classes={classes} variant={variant} variantMapping={variantMapping} ref={ref} {...restProps} />
    )
  },
) as TypographyType

Typography.displayName = 'Typography'
